import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Alert from '../components/home/Alert';

class NoPermissionPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: true,
      alertMessage: 'You do not have the correct permissions to access this page.',
    };
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  render() {
    return (
      <Alert
        alertOpen={this.state.alertOpen}
        alertHandleClose={() => browserHistory.goBack()}
        alertMessage={this.state.alertMessage}
      />
    );
  }
}

NoPermissionPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    error: state.error,
  };
}

export default connect(mapStateToProps)(NoPermissionPage);



// WEBPACK FOOTER //
// ./src/containers/NoPermissionPage.js